//import { useSelector, useDispatch } from 'react-redux';

/**
 * Crée un Work + Agent + Contribution + Expression + Manifestation
 * selon le modèle RDA-FR (langue sur Expression).
 *
 * @param {string} token JWT (Authorization)
 * @param {Object} data
 * @param {string} data.title                 Titre de l'œuvre
 * @param {string} data.genre                 Genre ("Roman", "Poésie", ...)
 * @param {string} data.originalLanguage      Langue originale de l'œuvre ("fr", "en", ...)
 * @param {string} data.authorName            Nom de l'auteur ("Jules Verne")
 * @param {string} data.authorType            Type d'agent ("Personne", "Collectivité")
 * @param {string} data.expressionTitle       Titre de l'expression (souvent = titre de l'œuvre)
 * @param {string} data.expressionLanguage    Langue de l'expression ("fr", "en", ...)
 * @param {string} data.manifestationTitle    Titre de la manifestation ("Édition Hetzel")
 * @param {string} data.publisher             Éditeur
 * @param {string} data.pubDate               Date de publication ("1873", "2020-01-01", ...)
 * @param {string} data.isbn                  ISBN (optionnel mais recommandé)
 */
async function CreateBookReview(API_BASE, token, data) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${token}`,
  };

  const workRes = await fetch(`${API_BASE}/works/review`, {
    method: "POST",
    headers,
    body: JSON.stringify(data),
  });

  if (!workRes.ok) {
    throw new Error("Erreur création Work: " + (await workRes.text()));
  }
  const work = await workRes.json();
  //console.log("Work:", work);



  // On renvoie tout l'ensemble
  return {
    work,
  };
}
export default CreateBookReview;